import gql from 'graphql-tag'
export default gql`mutation deletePlantMutation($plantId: Int!) {
  deletePlant(plantId: $plantId) {
    success
  }
}`